/*
 * Copyright (c) 2020 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.common.properties

abstract class AbstractMutableProperty<T> : AbstractProperty<T>(), MutableProperty<T> {
//    override fun bind(source: Property<T?>?) {
//        val binding: PropertyListener<T?> = object : PropertyListener<T?>() {
//            override fun propertyChanged(event: PropertyEvent<T?>?) {
//                setValue(event!!.newValue)
//            }
//        }
//        source!!.addPropertyListener(binding)
//        setValue(source.value)
//    }
//
//    override fun bindBidirectional(source: MutableProperty<T?>?) {
//        source!!.addPropertyListener(object : PropertyListener<T?>() {
//            override fun propertyChanged(event: PropertyEvent<T?>?) {
//                setValue(event!!.newValue)
//            }
//        })
//        addPropertyListener(object : PropertyListener<T?>() {
//            override fun propertyChanged(event: PropertyEvent<T?>?) {
//                source!!.setValue(event!!.newValue)
//            }
//        })
//        setValue(source.value)
//    }
}